export default {
	editorPanel: {
		minimizeTooltip: "minimizza",
		readOnlySuffix: "(sola lettura)",
		featureModeTooltip: "Selezionare e inserire/modificare lavorazioni per filettature, svasature ecc.",
		measuringModeTooltip: "Misurare la geometria",
		weldModeTooltip: "Definire il cordone di saldatura",
		weldModeDisabledTooltip:
			"Questo materiale attualmente non può essere saldato. Le informazioni sui materiali " +
			"saldabili sono disponibili su blexon.com/werkstoffe",
		rollDirectionModeTooltip: "Definire la direzione di laminazione",
		switchTopSideTooltip: "Cambiare il lato superiore",
		zoomToFit: "Adatta alla vista",
		noValidationLabel: "Nessuna convalida",
	},
	errorDialog: {
		closeButton: "Chiudi",
	},
	messagePanel: {
		noMessages: "Nessun messaggio",
	},
	modePanel: {
		minimizeTooltip: "minimizza",
		noModeSelected: "Al momento non è selezionata alcuna modalità.",
	},
	sendToHelpdesk: {
		title: "Invia l'articolo all'helpdesk Blexon",
		introText:
			"State inviando questo articolo all'helpdesk Blexon. Verificheremo la causa dei " +
			"messaggi di errore e, se possibile, la correggeremo. Siamo inoltre lieti di fornirvi " +
			"indicazioni su come modificare la costruzione affinché l'articolo diventi " +
			"realizzabile. Questo servizio è gratuito.",
		notificationText:
			"Sarete informati via e-mail non appena l'articolo sarà stato elaborato. La verifica " +
			"avviene generalmente entro poche ore durante l'orario di apertura.",
		lockNotice:
			"Vi preghiamo di notare che dopo l'invio l'articolo non potrà più essere modificato o " +
			"eliminato fino a quando non sarà stato approvato da Blexon.",
		emailLabel: "E-mail per le notifiche relative a questo articolo",
		emailPlaceholder: "Inserite qui l'indirizzo e-mail...",
		emailRequiredError: "È necessario indicare un indirizzo e-mail.",
		emailInvalidError: "Questo non è un indirizzo e-mail valido.",
		submitButton: "Invia e chiudi",
		cancelButton: "Annulla",
	},
	unsavedChanges: {
		title: "Alcune modifiche non sono ancora state salvate.",
		message: "Volete annullare le modifiche?",
		discardButton: "Annulla modifiche",
		cancelButton: "No",
	},
	validationMessage: {
		showFeaturesTooltip: "Mostra le funzioni nel modello",
		correctTooltip: "Correggi",
		learnMoreLink: "Scopri di più qui...",
		releaseCutsWarningTitle: "Crea taglio di sgancio nella zona di piegatura",
		releaseCutsWarningText1:
			"Durante la creazione dei tagli di sgancio, le filettature, le svasature, i colletti " +
			"estrusi e le svasature per vite a testa cilindrica esistenti andranno perdute e " +
			"dovranno essere ridefiniti in seguito.",
		releaseCutsWarningText2:
			"Consigliamo di creare i tagli di sgancio nella zona di piegatura all'inizio della lavorazione.",
		createReleaseCutsButton: "Crea taglio di sgancio",
		cancelButton: "Annulla",
	},
	cadView: {
		gizmoRight: "Destra",
		gizmoLeft: "Sinistra",
		gizmoTop: "Sopra",
		gizmoBottom: "Sotto",
		gizmoFront: "Fronte",
		gizmoBack: "Retro",
	},
};
